var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',_vm._g({class:{
    [`button-${_vm.variant}`]: ['primary', 'dashed', 'danger', 'ghost', 'default'].indexOf(_vm.variant)<0,
    'button-shadow': _vm.shadow,
    'rounded': _vm.rounded
  },attrs:{"block":_vm.block,"disabled":_vm.disabled,"ghost":_vm.outline,"loading":_vm.loading,"shape":_vm.shape,"size":_vm.size,"type":['primary', 'dashed', 'danger', 'ghost', 'default'].indexOf(_vm.variant) >= 0 ? _vm.variant : 'primary'}},_vm.$listeners),[_vm._t("default",function(){return [_vm._v("Button")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }